module.exports = __webpack_public_path__ + "static/media/RenewableEnergy.e6e32a55.png";